import { ProfileService } from './../../profile/profile.service';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppComponent } from '../../app.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRightToBracket, faArrowRightFromBracket, faTarp } from '@fortawesome/free-solid-svg-icons';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header-mini',
  standalone: true,
  imports: [RouterModule, CommonModule, FontAwesomeModule],
  templateUrl: './header-mini.component.html',
  styleUrl: './header-mini.component.css'
})
export class HeaderMiniComponent {
  showMenu = false;
  faArrowRightToBracket = faArrowRightToBracket;
  faArrowRightFromBracket = faArrowRightFromBracket;
  faTarp = faTarp;

  authService: AuthService;
  profileService: ProfileService;
  app: AppComponent;
  showHeader: boolean =  true;

  constructor() {
    this.authService = inject(AuthService);
    this.profileService = inject(ProfileService);
    this.app = inject(AppComponent);
    const self = this;
    this.app.headerStatusObservable.subscribe((e) => {
      self.showHeader = e;
    });
    console.log(this.app);
  }

  logOut() {
    if (this.app != undefined)
      this.app.logOut();
  }
}
